// extracted by mini-css-extract-plugin
export default {"list":"index_list_ibv3k","img":"index_img_kQjBP"};